import Page from "@/shared/page";
import { COMPANY_DOCUMENTS_EDIT_PATH } from "./company-documents-edit-path";
import { SaveCompanyDocumentsForm } from "../../features/save-company-documents";
import { useParams } from "react-router-dom";
import Card from "@/shared/data-display/card";
import { useEntityName } from "@/shared/breadcrumbs";
import { AllTokens, NamedTypes } from "gql/graphql";
import { Guard } from "@/shared/security/model/guard/guard";
import { useTranslations } from "use-intl";
import { CompanyDocumentsEditTabs } from "./company-documents-edit-tabs";
import { CompanyDocumentParticipants } from "@/modules/documents/widgets/company-document-participants";

export default function CompanyDocumentsEdit() {
  return (
    <Guard.Redirect.IfCantModify.PageNotFound
      influencedBy={[AllTokens.DocumentsCompanyManage]}
    >
      <CompanyDocumentsEditContent />
    </Guard.Redirect.IfCantModify.PageNotFound>
  );
}

function CompanyDocumentsEditContent() {
  const t = useTranslations("Documents");

  const { documentId, tab } = useParams<{ documentId: string; tab: string }>();
  const document = useEntityName(documentId, NamedTypes.CommonCompanyDocument);

  if (!documentId) {
    return null;
  }

  return (
    <Page
      title={t("Edit company documents")}
      breadcrumbsOptions={{
        path: COMPANY_DOCUMENTS_EDIT_PATH,
        entityNames: {
          documentId: document,
          tab: tab ? t(tab) : "",
        },
      }}
    >
      <Page.Grid>
        <Card>
          <CompanyDocumentsEditTabs
            tab={tab}
            documentId={documentId}
            general={<SaveCompanyDocumentsForm id={documentId} />}
            participants={<CompanyDocumentParticipants id={documentId} />}
          />
        </Card>
      </Page.Grid>
    </Page>
  );
}
